import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {IndexCards} from '../IndexCards';

@Component({
    selector: 'app-medarbejder-selector',
    templateUrl: './medarbejder-selector.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class MedarbejderSelectorComponent {
    @Input() employees: IndexCards[] = [];

    selectedEmployees: Set<number> = new Set();

    constructor(public activeModal: NgbActiveModal) {}

    toggleEmployee(employeeId: number): void {
        if (this.selectedEmployees.has(employeeId)) {
            this.selectedEmployees.delete(employeeId);
        } else {
            this.selectedEmployees.add(employeeId);
        }
    }

    isSelected(employeeId: number): boolean {
        return this.selectedEmployees.has(employeeId);
    }

    toggleAll(): void {
        if (this.isAllSelected()) {
            this.selectedEmployees.clear();
        } else {
            this.employees.forEach(emp => {
                this.selectedEmployees.add(emp.cardId);
            });
        }
    }

    isAllSelected(): boolean {
        return this.employees.length > 0 &&
            this.selectedEmployees.size === this.employees.length;
    }

    save(): void {
        const selectedEmployeeIds = Array.from(this.selectedEmployees);
        this.activeModal.close(selectedEmployeeIds);
    }

    cancel(): void {
        this.activeModal.dismiss();
    }
}
